import React, { useState, useEffect, useCallback } from 'react';
import Table from '../components/table/table';
import SubNav from '../components/subNav/subNav';
import RevocationsData from '../data/revocations.json';
const { revocationsData } = { ...RevocationsData }
import DisplayModal from '../modals/displayModal/displayModal';
import { createRevocationData, updateRevocationData, fetchRevocationData, deleteRevocationData, fetchRevocationGlobalSearchData, fetchCrlSignerCertificateData, publishRevocationDCL, deleteRevocationDCL } from '../api/revocationsApi';
import Loader from '../components/loader/loader';
import { exportToExcel } from '../functions/exportToExcel';
import debouce from 'lodash/debounce';
import { parseReqBodyNumber } from '../genericFunctions/parseReqBody';
import { NullUndefinedCheck } from '../genericFunctions/nullUndefinedCheck';
import { searchProductData } from '../api/productsApi';
import handle_toast  from '../genericFunctions/toast_Handler';


const Revocation = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [revocationData, setRevocationData] = useState([]);
  const [dataFetched, setDataFlag] = useState(false);
  const publishTo = 'Test';
  const accessData = sessionStorage.getItem('accessData') ? JSON.parse(sessionStorage.getItem('accessData'))['Revocation'] : {};

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  }
  // debounce call
  const debouncedCall = useCallback(
    debouce(()=> {
      fetchRevocations();
      fetchCrlSignerCertificate();
    }, 500), //Adjusting the delay
    []
  );

  useEffect(() => {
    if (!dataFetched) debouncedCall();
    
    //Clean up the debounce on component unmount
    return () => {
      debouncedCall.cancel();
    };
  }, [dataFetched, debouncedCall])

  const fetchRevocations = async () => {
    setIsLoading(true)
    try {
      const resp = await fetchRevocationData();
      setRevocationData(resp?.data?.data)
      setDataFlag(true)
      setIsLoading(false)
      handle_toast({message: `Revocation data fetched`, status: 'success'})
    }
    catch (error) {
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  // const fetchVid = async (productId) => {
  //   setIsLoading(true)
  //   try {
  //     const resp = await fetchVidForPid({pid: productId});
  //     setDataFlag(true)
  //     setIsLoading(false)
  //     return resp?.data?.data;
  //   }
  //   catch (error) {
  //     setIsLoading(false)
  //     setDataFlag(true);
  //     handle_toast(error)
  //   }
  // }

  const fetchCrlSignerCertificate = async () => {
    setIsLoading(true)
    try {
      const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
      const resp = await fetchCrlSignerCertificateData();
      const crlSignerCertificateList = [];
      resp?.data?.data?.map((obj) => {
        crlSignerCertificateList.push({ name: obj.subject, id: obj.id, crlSignerCertificate: obj.crlSignerCertificate, checked: false })
      })
      dropDownData.CRLSignerCertificate = crlSignerCertificateList;
      sessionStorage.setItem('dropDownData', JSON.stringify(dropDownData));
      setDataFlag(true)
      setIsLoading(false)
      handle_toast({message: `CRL signer certificate data fetched`, status: 'success'})
    }
    catch (error) {
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const fetchGlobalSearch = async (searchFormFields) => {
    try {
      const resp = await fetchRevocationGlobalSearchData(searchFormFields);
      setIsLoading(false);
      setDataFlag(true)
      setRevocationData(resp?.data?.globalSearchData)
      handle_toast({message: `Filtered revocation data fetched`, status: 'success'})
    }
    catch (error) {
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const handleEdit = async (formData) => {
    setIsLoading(true)
    try {
      const resp = await updateRevocationData(formData)
      if (resp?.status == 200) {
        handle_toast({message: `Revocation updated`, status: 'success'})
        fetchRevocations();
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleDelete = async (formData) => {
    setIsLoading(true)
    let dclResp, revocationResp = null;
    try{
      dclResp = publishTo == 'Test' ? await deleteRevocationDCL(parseReqBodyNumber(formData), 'test') : await deleteRevocationDCL(parseReqBodyNumber(formData), 'main')
      revocationResp = await deleteRevocationData(parseReqBodyNumber(formData))
      if(dclResp && revocationResp){
        handle_toast({message: `Revocation deleted, Removed from DCL`, details: `${publishTo == 'Test' ? `https://testnet.iotledger.io/models` : `https://webui.dcl.csa-iot.org/models`}`, status: 'success'})
        fetchRevocations();
        setIsLoading(false)
      }
    }
    catch (error) {
      handle_toast(error)
      if(NullUndefinedCheck(revocationResp)){
        if(!NullUndefinedCheck(dclResp)) {
          handleDelete(formData)
        }
        fetchRevocations();
        setIsLoading(false)
      }
    }
  }

  const excelExport = () => {
    exportToExcel(revocationData, revocationsData.revocationsHeaders, 'Revocation')
  }

  const handleSave = async (formValue) => {
    if (formValue.docType === 'DAC') {
      let dclTestResp, dclMainResp, productStatus, revocationResp = null;
      const productData = await searchProductData({ 'matterProductId': formValue.productId });
      if(productData?.data?.data.length > 0) {
        formValue['vid'] = productData?.data?.data[0].vid;
        productStatus = productData?.data?.data[0].status
      }
      try{
        if(productStatus == 'Published') {
          dclMainResp = await publishRevocationDCL(parseReqBodyNumber(formValue), 'main')
          dclTestResp = await publishRevocationDCL(parseReqBodyNumber(formValue), 'test')
        }
        if(productStatus == 'Test') dclTestResp = await publishRevocationDCL(parseReqBodyNumber(formValue), 'test')
        revocationResp = await createRevocationData(parseReqBodyNumber(formValue))
        if(dclMainResp && dclTestResp && revocationResp && productStatus == 'Published'){
          handle_toast({message: `Revocation DAC Created, Published to DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
          fetchRevocations();
          setIsLoading(false)
        }
        if(dclTestResp && revocationResp && productStatus == 'Test'){
          handle_toast({message: `Revocation DAC created, Published to DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
          fetchRevocations();
          setIsLoading(false)
        }
      }
      catch (error) {
        handle_toast(error)
        if(NullUndefinedCheck(revocationResp)){
          if(!NullUndefinedCheck(dclTestResp)) {
            await deleteRevocationDCL(parseReqBodyNumber(formValue), 'test')  
          }
          if(!NullUndefinedCheck(dclMainResp)) {
            await deleteRevocationDCL(parseReqBodyNumber(formValue), 'main') 
          }
          fetchRevocations();
          setIsLoading(false)
        }
      }
    }
    if (formValue.docType === 'PAI') {
      let dclMainResp, dclTestResp, revocationResp = null;
      if(formValue.paiCert) {
        const regex = /vid=([^,]+)/;
        const match = formValue.paiCert.match(regex)
        if(match) formValue['vid'] = match[1];          
      }
      try{
        dclTestResp =  await publishRevocationDCL(parseReqBodyNumber(formValue), 'test');
        dclMainResp = await publishRevocationDCL(parseReqBodyNumber(formValue), 'main')
        revocationResp = await createRevocationData(parseReqBodyNumber(formValue))
        if(dclTestResp && dclMainResp && revocationResp){
          handle_toast({message: `Revocation PAI created, Published to DCL, https://testnet.iotledger.io/models, https://webui.dcl.csa-iot.org/models`, status: 'success'})
          fetchRevocations();
          setIsLoading(false)
        }
      }
      catch (error) {
        handle_toast(error)
        if(NullUndefinedCheck(revocationResp)){
          if(!NullUndefinedCheck(dclTestResp) && !NullUndefinedCheck(dclMainResp)) {
            await deleteRevocationDCL(parseReqBodyNumber(formValue), 'test')
            await deleteRevocationDCL(parseReqBodyNumber(formValue), 'main')
          }
          fetchRevocations();
          setIsLoading(false)
        }
      }
    }
  }
  

  const handleRevokDownload = async (formData) => {
    window.open(formData.crlLink, '_blank');
  }

  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && <SubNav data={revocationsData.revocationsSubNav} access={accessData} handleModalClick={toggleModal} sendReset={fetchRevocations} excelExport={excelExport} handleDDSearch={fetchGlobalSearch}></SubNav>}
      <se-container>
        <se-divider option='vertical'></se-divider>
        <div className='tableContainer'>
          <Table columns={revocationsData.revocationsHeaders} access={accessData} body={revocationData} modalData={revocationsData.revocationsModalData} onSave={handleEdit} onDelete={handleDelete} selection={false} page="revocation"  onDownload={handleRevokDownload}/>
        </div>
      </se-container>
      {modalVisible && <DisplayModal toggleModal={toggleModal} data={revocationsData.revocationsModalData} source="create" page="revocation" onSave={handleSave} />}
    </>
  );
};
export default Revocation;

